__turbopack_context__.v({
  "tag": "CompanyTag-module-scss-module__qVGWpq__tag",
});
